import { useTranslation } from "@/Common/CustomHooks/useTranslation";
import { ResourceProvider } from "@/Common/Resources/StaticResources";
import { Button } from "@/DesignSystem";

import styles from "./LoginWithExternalIdentityProviderView.module.scss";

export interface ILoginWithExternalIdentityProviderViewProps {
    stringProvider: ResourceProvider;
    onSubmit: (provider: string) => void;
    hasExternalError?: boolean;
}

export function LoginWithExternalIdentityProviderView(props: Readonly<ILoginWithExternalIdentityProviderViewProps>): JSX.Element {
    const stringProvider = props.stringProvider;
    const { getText } = useTranslation(stringProvider);

    const identityProviders = cacheStore.ClinicSettingsSingleSignOnProviders.map(provider => provider.ProviderName);

    const providerLabelMap: Record<string, string> = {
        islh: getText("ExternalAuthentication_ProviderVihaLabel")
    };

    function getProviderLabel(provider: string): string {
        return providerLabelMap[provider.toLowerCase()] ?? provider;
    }

    return (
        <>
            {identityProviders.map(provider => {
                const label = getText("ExternalAuthentication_LoginWithExternalIdentityProviderLabel", { provider: getProviderLabel(provider) });
                return (
                    <div className={styles.loginButtonContainer} key={provider}>
                        <Button
                            variant="brand"
                            data-cy="LoginWithExternalIdentityProvider-button"
                            onClick={() => props.onSubmit(provider)}
                            label={label}
                            size="lg"
                        />
                    </div>
                );
            })}
            {props.hasExternalError && (
                <div data-cy="NewExperienceLogin-external-error-message" className="error-message">
                    <strong>
                        {props.stringProvider.GetString("LoginFailed")}
                    </strong>
                </div>
            )}
        </>
    );
}
